import { render, staticRenderFns } from "./codeLogin.vue?vue&type=template&id=18a1909e&scoped=true"
import script from "./codeLogin.vue?vue&type=script&lang=js"
export * from "./codeLogin.vue?vue&type=script&lang=js"
import style0 from "./codeLogin.vue?vue&type=style&index=0&id=18a1909e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1909e",
  null
  
)

export default component.exports